module.exports = __webpack_public_path__ + "img/19.e1c12c45.gif";